import { configureStore } from '@reduxjs/toolkit';
import walletReducer from '@widgets/WalletWrapper/store/reducers/wallet';
export const storeOptions = {
    reducer: {
        wallet: walletReducer,
    },
};
const store = configureStore(storeOptions);
export default store;
